import { Expose } from "class-transformer";
import { observable } from "mobx";
import { SupplyPointError } from "../helpers/supplyPointHelper";

export default class SupplyPointsChangeStatus {
  @observable
  @Expose({ name: "supply_points" })
  supplyPoints!: SupplyPointError[];
}
